import React, { useEffect, useState, useRef } from 'react';

const Counter = ({ target, duration }) => {
  const [count, setCount] = useState(0);
  const ref = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          startCounting(); // Start or restart the count every time it's visible
        }
      },
      { threshold: 0.5 } // 50% visible
    );

    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const startCounting = () => {
    setCount(0); // reset before starting

    let current = 0;
    const end = parseFloat(target);
    const increment = end / (duration / 10);

    const interval = setInterval(() => {
      current += increment;
      if (current >= end) {
        clearInterval(interval);
        setCount(end);
      } else {
        setCount(parseFloat(current.toFixed(1)));
      }
    }, 10);
  };

  return (
    <span ref={ref}>
      {count.toLocaleString()}<span className="fw-normal">+</span>
    </span>
  );
};

export default Counter;
